import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'

import { buildPresetMenu, getPresetFromID } from '../utilities'

import PresetManagerSelectDestination from './PresetManagerSelectDestination'
import UnsavedChanges from './UnsavedChanges'

import tooltips from '../constants/tooltips.json'

import {
  setCurrentPreset,
  initialPresetLoad,
  openUnsavedChangesModal,
  networkStatus
} from '../actions/'

class PresetManagerSelect extends Component {
  state = {
    unsavedChangesOpen: false,
    presetRef: '',
  };

  componentDidMount() {
    const component = this,
      timeLimit = 1500,
      ricTimeout = 3000,
      mountedTime = new Date().getTime();
    if ("requestIdleCallback" in window) {
      component.idle = window.requestIdleCallback(
        function loadInitialPreset(deadline) {
          const {
            presets,
            deviceConnected,
            devicePresetsLoaded,
            onInitialPresetLoad,
          } = component.props;

          let presetName,
            timeLimitReached = new Date().getTime() - mountedTime > timeLimit;

          if (timeLimitReached || (deviceConnected && devicePresetsLoaded)) {
            if (presets.device.length > 0) {
              presetName = "device-0";
            } else if (presets.user.length > 0) {
              presetName = "user-0";
            } else if (presets.factory.length > 0) {
              presetName = "factory-0";
            }
            // load initial preset
            onInitialPresetLoad(
              getPresetFromID(presets, presetName),
              presetName
            );
          } else {
            component.idle = window.requestIdleCallback(loadInitialPreset, {
              timeout: ricTimeout,
            });
          }
        },
        { timeout: ricTimeout }
      );
    } else {
      // setTimeout
    }
  }

  componentDidUpdate() {
    this.props.onSetNetworkStatus();
  }

  componentWillUnmount() {
    window.cancelIdleCallback(this.idle);
  }

  render() {
    const {
      presets,
      selectedPreset,
      onPresetChange,
      revertablePreset,
      onOpenUnsavedChangesModal,
      showTooltips,
    } = this.props;

    return (
      <div className="preset-manager-select">
        <div className="presets-label">presets</div>
        <div className="presets-box">
          <Select
            name="presets"
            value={selectedPreset}
            data-tip={tooltips["preset-select"]}
            data-multiline="true"
            data-tip-disable={!showTooltips}
            options={buildPresetMenu(presets)}
            onChange={(id) => {
              if (revertablePreset) {
                this.setState({ ...this.state, presetRef: id });
                onOpenUnsavedChangesModal();
              } else {
                onPresetChange(getPresetFromID(presets, id), id);
              }
            }}
          />
          <PresetManagerSelectDestination />
          {revertablePreset && <UnsavedChanges presetID={this.state.presetRef} />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    presets: state.presets,
    selectedPreset: state.editor.selectedPreset,
    revertablePreset: state.editor.revertablePreset,
    deviceConnected: state.device.connected,
    devicePresetsLoaded: state.editor.devicePresetsLoaded,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onInitialPresetLoad: (preset, id) => {
      dispatch(initialPresetLoad(preset, id))
    },
    onPresetChange: (preset, id) => {
      dispatch(setCurrentPreset(preset, id))
    },
    onSetNetworkStatus: () => {
      dispatch(networkStatus())
    },
    onOpenUnsavedChangesModal: () => {
      dispatch(openUnsavedChangesModal())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PresetManagerSelect)
